


































































































































import {
  apiBlindBoxHomeActivityIndex,
  ApiBlindBoxHomeActivityIndexResponse,
  apiBlindBoxHomePrizeDanMu,
  ApiBlindBoxHomePrizeDanMuResponse,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import {
  defineClassComponent,
  useApiPlus,
  useHandler,
  useQuery,
  useShareParams,
} from '@/hooks'
import { devOrProd, Track } from '@/utils'
import { navigateTo } from '@/router'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '首页',
        }))
      }

      loading = computed(() => this.apiData.loading)

      shareParams = useShareParams(
        devOrProd(
          '8aaa9213826d16b701828aaf84ea0001',
          '8aaa8449826d86ef01828ab71a210008',
        ),
        true,
      )

      query = useQuery<{
        id: string
      }>()

      boxIndex = ref(0)

      apiData = useApiPlus({
        boxData: () =>
          apiBlindBoxHomeActivityIndex(
            {
              id: this.query.id,
            },
            {
              noErrorToast: true,
            },
          ).catch(() => ({} as ApiBlindBoxHomeActivityIndexResponse)),
        danmuData: () =>
          apiBlindBoxHomePrizeDanMu(
            {
              id: this.query.id,
            },
            {
              noErrorToast: true,
            },
          ).catch(() => ({} as ApiBlindBoxHomePrizeDanMuResponse)),
        animateData: () => import('./images/首页动画.json'),
      })

      boxData = computed(() => this.apiData.data.boxData)

      animateData = computed(() => this.apiData.data.animateData)

      isPrepare = computed(() => !this.boxData.value.boxs?.length)

      danmuText = computed(() =>
        this.apiData.data.danmuData.map(item => item.text).join('　　'),
      )

      showMoreBox = ref(false)

      handleServiceClick = useHandler<
        '活动规则' | '我的盒柜' | '马上来玩' | '更多盲盒'
      >({
        活动规则: () =>
          navigateTo('BoxRule', {
            id: this.query.id,
          }),
        我的盒柜: () =>
          navigateTo('BoxOrderList', {
            id: this.query.id,
          }),
        马上来玩: () =>
          navigateTo('BoxDetail', {
            id: this.boxData.value.boxs![this.boxIndex.value].boxId,
          }),
        更多盲盒: () => {
          this.showMoreBox.value = true
        },
      })
    },
)
